import { useUser } from "../useUser";

export const useShouldShowSubscriptionOverhaul = (): boolean => {
  const { allstarUser } = useUser();
  const email = allstarUser?.decoded?.sub;

  if (process.env.REACT_APP_SUBSCRIPTION_OVERHAUL === "true") return true;
  if (email?.endsWith("@allstar.gg")) return true;
  return false;
};
